import Head from 'next/head'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from '@/components/layouts/MainLayout'
import nextI18nextConfig from 'next-i18next.config'
import {
  localBusinessSchema,
  ogImage,
  serviceSchema,
  siteUrl
} from 'lib/seoConfigs'

export default function OtAwarenessTraining() {
  const { t } = useTranslation('servicesOtAwarenessTraining')

  const router = useRouter()
  const currentLocale = Array.isArray(router.query.locale)
    ? router.query.locale[0]
    : router.query.locale || nextI18nextConfig.i18n.defaultLocale

  const path =
    currentLocale === 'de'
      ? 'de/dienstleistungen/ot-awareness-training'
      : 'en/services/ot-awareness-training'

  return (
    <>
      <Head>
        {/* Basic Meta */}
        <title>{t('title')}</title>
        <meta name="description" content={t('description')} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="content-language" content={currentLocale} />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        {/* Favicon */}
        <link rel="shortcut icon" href="/favicon.ico" />

        {/* Canonical */}
        <link rel="canonical" href={`${siteUrl}/${path}/`} />

        {/* Hreflang for localization */}
        <link
          rel="alternate"
          hrefLang="de"
          href={`${siteUrl}/de/dienstleistungen/ot-awareness-training/`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`${siteUrl}/en/services/ot-awareness-training/`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`${siteUrl}/de/dienstleistungen/ot-awareness-training/`}
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={t('title')} />
        <meta property="og:description" content={t('description')} />
        <meta property="og:url" content={`${siteUrl}/${path}/`} />
        <meta property="og:image" content={ogImage} />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('title')} />
        <meta name="twitter:description" content={t('description')} />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD LocalBusiness */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(localBusinessSchema)
          }}
        />

        {/* Schema.org Service node for this offering */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              serviceSchema({
                name: t('title'),
                description: t('description'),
                url: `${siteUrl}/${currentLocale === 'de' ? 'dienstleistungen/ot-awareness-training' : 'services/ot-awareness-training'}/`
              })
            )
          }}
        />
      </Head>

      {/* Page Content */}
      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="services/ot-awareness-training" />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps([
  'common',
  'servicesOtAwarenessTraining'
])
export { getStaticPaths, getStaticProps }
